/**
 * How the kiosk lays out an item's customisation, from the merchant's `branding.settings.layout`.
 *
 * The panel sends a free string; this is the one place it becomes one of the kiosk's two layouts, so a
 * screen never compares the raw string (DP-7554-v8 compared it in four screens, merged 2026-10-23).
 */

/** The two customise layouts: one option step per page, or every step on one scrolling page. */
export const KIOSK_CUSTOMISE_LAYOUTS = {
  /** One step at a time, with a steps bar and Next (`GuidedStepsTemplate`). */
  guidedSteps: "guided-steps",
  /** Every step on one page (`SinglePageTemplate`): the kiosk's default. */
  singlePage: "single-page",
} as const;

/** One of the kiosk's customise layouts. */
export type KioskCustomiseLayout = (typeof KIOSK_CUSTOMISE_LAYOUTS)[keyof typeof KIOSK_CUSTOMISE_LAYOUTS];

/**
 * The layout a merchant's setting asks for. Only `"guided-steps"` picks the guided layout; anything
 * else, or nothing, is the single page. Example: `customiseLayoutOf("guided-steps")` → `"guided-steps"`;
 * `customiseLayoutOf(undefined)` → `"single-page"`.
 */
export function customiseLayoutOf(setting: string | undefined): KioskCustomiseLayout {
  return setting === KIOSK_CUSTOMISE_LAYOUTS.guidedSteps
    ? KIOSK_CUSTOMISE_LAYOUTS.guidedSteps
    : KIOSK_CUSTOMISE_LAYOUTS.singlePage;
}
